import {ReactElement} from 'react';
import {I18n} from 'aws-amplify/utils';
import {Box} from '@mantine/core';
import {
    ReloadButton,
    SimplePageHeader,
} from '@flexinet/ui-components';

import {useProviderConnections} from '../hooks/useProviderConnections';
import {ConnectProviderButton} from '../buttons/ConnectProviderButton';
import config from '../config';

const ProviderConnectionsReloadButton = () => {
    const {reload} = useProviderConnections();
    return (
        <Box mx={'s'}>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};

// ⚠️ NO DELETE TOOL IN THIS TOOLBAR, and that is the module's central safety
// decision rather than an omission.
//
// Disconnecting MUST go through `previewProviderDisconnect` and render its
// consequences and zone count. A toolbar delete acting on a checkbox selection
// cannot do that honestly: the preview is per-connection, there is no batch
// preview on the schema, and summarising several connections' consequences in
// one dialog would be inventing content the API never produced. Disconnect
// lives on the detail page where the preview has room to be read.
const useTools = (): ReactElement[] => {
    return [
        <ConnectProviderButton key={'connect'}/>,
        <ProviderConnectionsReloadButton key={'reload'}/>,
    ];
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
